import { buildInstanceWanda, instance } from '@/api/instances'

const instanceWanda = buildInstanceWanda()

const fetchHealthcareMap = async (
  store,
  { healthcareTeamId, filter, sortBy, orderBy, range }
) => {
  try {
    return await instanceWanda.get(`healthcare_map/${healthcareTeamId}`, {
      params: {
        filter: JSON.stringify(filter),
        sort: JSON.stringify([sortBy, orderBy]),
        range: JSON.stringify(range)
      }
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthcareMap/fetchHealthcareMap' },
      { root: true }
    )
  }
}

const fetchHealthcareTeams = async store => {
  try {
    const teams = await instanceWanda.get(`healthcare_teams/by_staff_v2`)

    store.commit('setHealthCareTeam', teams)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthcareMap/fetchHealthcareTeams' },
      { root: true }
    )
  }
}
const fetchHealthcareMapOverview = async (_, { healthcareTeamId, type }) => {
  const params = { type }
  return await instanceWanda.get(
    `healthcare_map/${healthcareTeamId}/overview`,
    { params }
  )
}

const fetchPresetFilterOptions = async store => {
  try {
    return await instanceWanda.get('healthcare_map/filters/preset')
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthcareMap/fetchPresetFilterOptions' },
      { root: true }
    )
  }
}

const fetchPConditionsFilterOptions = async (store, { query, presetIds }) => {
  try {
    const parsedPresets = presetIds?.length ? `&presetIds=${presetIds}` : ''
    return await instanceWanda.get(
      `healthcare_map/filters/conditions?query=${query}${parsedPresets}`
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthcareMap/fetchPConditionsFilterOptions' },
      { root: true }
    )
    return []
  }
}

const fetchLiteProfile = async (store, personId) => {
  if (store.rootState.healthcareMap.profiles[personId]) return

  try {
    const normalizedResponse = await instance.get(`person/${personId}/light`)

    store.commit('setLiteProfile', {
      ...normalizedResponse,
      personId: personId
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthcareMap/fetchLiteProfile' },
      { root: true }
    )
  }
}

const fetchCaseRecords = async (store, personId) => {
  if (store.rootState.healthcareMap.caseRecords[personId]) return

  try {
    const casesList = await instance.get(`persons/${personId}/case_records`)

    const sortedCasesList = casesList
      .sort((a, b) => {
        return (
          Date.parse(b.records[0].addedAt) - Date.parse(a.records[0].addedAt)
        )
      })
      .filter(item => {
        return item.status === 'ACTIVE' && item.severity !== 'INACTIVE'
      })

    const memberCases = {
      first: sortedCasesList.shift(),
      all: sortedCasesList,
      personId: personId
    }

    store.commit('setCaseRecords', memberCases)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthcareMap/fetchCaseRecords' },
      { root: true }
    )
  }
}

const fetchHealthEventById = async (store, eventId) => {
  if (store.rootState.healthcareMap.healthEvents[eventId]) return

  try {
    const healthEvent = await instanceWanda.get(
      `person_health_events/${eventId}`
    )

    store.commit('setHealthEvent', healthEvent)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthcareMap/fetchHealthEventById' },
      { root: true }
    )
  }
}

export default {
  fetchHealthcareMap,
  fetchHealthcareTeams,
  fetchPresetFilterOptions,
  fetchPConditionsFilterOptions,
  fetchLiteProfile,
  fetchCaseRecords,
  fetchHealthEventById,
  fetchHealthcareMapOverview
}
